import withCheckoutContext from '@/withCheckoutContext';
import { FlightSummaryMetaProvider } from '@/clientState/providers/FlightSummaryMetaProvider/FlightSummaryMetaProvider';

export default withCheckoutContext(FlightSummaryMetaProvider);
